import axios from 'axios';
import authConfig from '@/../auth_config.json';

export default axios.create({
    baseURL: 'https://api.intface.vn/',
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
})
